export default {
	SET_CURRENT_VERSION: 'SET_CURRENT_VERSION',
	SET_VERSIONS: 'SET_VERSIONS'
};
